import CityAirportTemplate from '../../components/templates/CityAirportTemplate';

export default function TaxiMaarssenSchipholPage() {
  return (
    <CityAirportTemplate
      city="Maarssen"
      airport="schiphol"
      airportName="Schiphol Airport"
      price={52.50}
      distance="42 km"
      duration="32-38 minuten"
    />
  );
}
